import axios from "axios";
export const baseURL = `${process.env.REACT_APP_API}/api`;
const instance = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// ✅ Interceptor for adding token automatically
instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling and token expiry detection
instance.interceptors.response.use(
  (response) => {
    // Check for token expiry in successful responses too
    if (response.data && response.data.tokenRemove === true) {
      // Clear all auth data
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("allowedPermissions");

      // Redirect to login page
      window.location.href = "/authentication/sign-in";
    }
    return response;
  },
  (error) => {
    console.error("API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url,
    });

    // Check if token is expired (backend returns tokenRemove: true)
    if (
      error.response?.data?.tokenRemove === true ||
      (error.response?.status === 401 && error.response?.data?.msg === "your token is expired")
    ) {
      // Clear all auth data from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("allowedPermissions");

      // Redirect to login page
      window.location.href = "/authentication/sign-in";
    }

    return Promise.reject(error);
  }
);

export default instance;
